import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WarningAmberIcon(props: IconProps) {
    return <Icon {...props} iconKey={"warning_amber"}/>
}
